<template>
  <div>
    <delivery-settings v-if="mode === 'edit'" @change-mode="changeMode" />
    <delivery-setting-list v-if="mode === 'query'" @change-mode="changeMode" />
  </div>
</template>

<script>
import DeliverySettings from './components/DeliverySettings.vue'
import DeliverySettingList from './components/DeliverySettingList.vue'
export default {
  components: { DeliverySettingList, DeliverySettings },
  data() {
    return {
      mode: 'edit'
    }
  },
  methods: {
    changeMode(mode) {
      this.mode = mode
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/deliverySetting.vue